/**
 * The Errors tile's status line (19/10/2026): critical ones first (a
 * person must act), then open ones with how many are resolved since
 * (21/10/2026) or whether Slack heard them, then
 * "all resolved", then no error — with "Slack off" when every error is
 * traced only.
 * For Media Devoted | Created By Ciro Autiero
 */
import type { DropGenErrorsSlackState } from '@trafficpulse/shared';

import type { ErrorFacts } from '../../errors-tab/errors-facts';
import type { FactStatus } from '../facts/generation-fact';

export function errorsStatus(facts: ErrorFacts | null, slack: DropGenErrorsSlackState | null): FactStatus {
  if (!facts) return { text: 'reading the trace…', tone: 'muted' };
  const onSlack = slack?.on ? 'every one on Slack' : 'Slack off — traced only';
  if (facts.critical > 0) return { text: `${facts.critical} critical — a person must act`, tone: 'warning' };
  if (facts.open > 0) return { text: `${facts.open} open · ${facts.resolved > 0 ? `${facts.resolved} resolved` : onSlack}`, tone: 'warning' };
  if (facts.today > 0) return { text: `all resolved · ${onSlack}`, tone: 'success' };
  return slack && !slack.on ? { text: 'No error today · Slack off', tone: 'warning' } : { text: 'No error today · every error → Slack', tone: 'success' };
}
